import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NavigationService } from 'src/app/services/navigation';

import Swal from 'sweetalert2';
import { NotificationService } from 'src/app/services/notification.service';
import { UserModel } from 'src/app/services/user-model';
import { AuthService } from 'src/app/services/auth.service';
import { UserService, UserType } from 'src/app/services/user.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-header-documentation',
  templateUrl: './header-documentation.component.html',
  styleUrls: ['./header-documentation.component.scss'],
})
export class HeaderDocumentationComponent implements OnInit {

  back_location = null;

  user$: Observable<UserType>;

  @Input() value: any;

  constructor(
    private router: Router,
    public userModel: UserModel,
    private nav: NavigationService,
    private toast: NotificationService,
    private userService: UserService,
    public authService: AuthService,
  ) {
    this.user$ = this.userService.currentUserSubject.asObservable();
  }

  ngOnInit() {}

  irInicio() {
    this.router.navigateByUrl('/');
    // this.navController.navigateRoot('inicio');
  }

  back() {
    this.nav.back()
  }

  logout(){
    Swal.fire({
      title: 'Cerrar Sesión',
      text: '¿Desea cerrar su Sesión?',
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'No',
      confirmButtonText: 'Sí',
    }).then((result) => {
      if(result.value) {
        // Swal.fire('Removed!', 'Product removed', 'success');
        this.cerrarSesion();
      } else if(result.dismiss === Swal.DismissReason.cancel) {
        // Swal.fire('Cancelled', 'Product still in our database.', 'error');
      }
    });
  }

  cerrarSesion() {
    this.authService.logout();
    this.toast.success('Sesión cerrada', 'Cerraste tu sesión exitosamente', 4000);
    let state = this.router.routerState.snapshot;
    console.log(state);
    if(state.url) { this.userModel.setRedirectUrl(state.url); }
  }

}